/* База знань і стандарти (/kb, docs/processes C15). Kept apart from uk.ts/en.ts to keep merges small. */
export const kbUk = {
  'nav.kb': 'База знань',
  'perm.kb.read': 'База знань: читання й ознайомлення',
  'perm.kb.manage': 'База знань: документи, публікація, реєстр ознайомлень',
  'perm.kb.approve_clinical': 'Затвердження клінічних позицій',
  'today.kbPending': 'Потрібно ознайомитися',
  'kb.title': 'База знань',
  'kb.subtitle': 'Регламенти, SOP, скрипти й інструкції клініки — з версіями, датами перегляду й ознайомленням',
  'kb.new': 'Документ',
  'kb.import': 'Імпорт',
  'kb.tab.docs': 'Документи',
  'kb.tab.positions': 'Клінічні позиції',
  'kb.tab.register': 'Ознайомлення',
  'kb.categories': 'Розділи',
  'kb.allCategories': 'Усі розділи',
  'kb.pendingCount': 'Чекають ознайомлення: {n}',
  'kb.search': 'Пошук у назвах і текстах',
  'kb.filter.allLevels': 'Усі рівні',
  'kb.filter.role': 'Для ролі',
  'kb.filter.allRoles': 'Усі ролі',
  'kb.filter.current': 'Чинні й чернетки',
  'kb.filter.pending': 'Потрібно ознайомитися',
  'kb.filter.review': 'Час переглянути',
  'kb.empty': 'Документів тут ще немає',
  'kb.emptyHint': 'Коли керівники опублікують регламенти для вашої ролі, вони з’являться тут.',
  'kb.emptyHintManager': 'Створіть документ або імпортуйте тексти (.md, .txt) кнопкою «Імпорт» — потім опублікуйте.',
  'kb.emptySearch': 'Спробуйте інше слово або початок слова — пошук іде за назвами, кодами й текстами.',
  'kb.hasFile': 'Є вкладення',
  'kb.draftPending': 'Є нова чернетка',
  'kb.reviewOn': 'Перегляд {date}',
  'kb.versionShort': 'Версія {n}',
  'kb.level': 'Рівень',
  'kb.level.policy': 'Політика',
  'kb.level.process': 'Процес',
  'kb.level.procedure': 'Процедура / SOP',
  'kb.level.form': 'Форма / шаблон',
  'kb.access': 'Доступ',
  'kb.access.all': 'Усі співробітники',
  'kb.access.roles': 'Обрані ролі',
  'kb.access.managers': 'Лише керівники',
  'kb.status': 'Статус',
  'kb.status.draft': 'Чернетка',
  'kb.status.published': 'Діє',
  'kb.status.archived': 'Архів',
  'kb.document': 'Документ',
  'kb.draftVersion': 'Чернетка, версія {n}',
  'kb.oldVersion': 'Попередня версія {n}',
  'kb.ack.ask': 'Прочитайте документ і підтвердіть ознайомлення',
  'kb.ack.button': 'Ознайомлений(а)',
  'kb.ack.thanks': 'Дякуємо, ознайомлення зафіксовано',
  'kb.ack.done': 'Ознайомлені',
  'kb.ack.doneAt': 'Ви ознайомилися {at}',
  'kb.ack.due': 'Ознайомитися до {date}',
  'kb.ack.overdue': 'Прострочено',
  'kb.ack.summary': 'Ознайомилися: {acked} з {targets}',
  'kb.ack.overdueCount': 'прострочено: {n}',
  'kb.owner': 'Відповідальний',
  'kb.ownerHint': 'Отримає нагадування про перегляд',
  'kb.effectiveOn': 'Діє з',
  'kb.reviewDate': 'Дата перегляду',
  'kb.reviewDateHint': 'Порожньо — за періодом від публікації',
  'kb.reviewMonths': 'Переглядати, міс.',
  'kb.reviewMonthsHint': 'Напр. 12; для інструкцій з ОП — 60 (36 для робіт підвищеної небезпеки)',
  'kb.version': 'Версія',
  'kb.source': 'Джерело',
  'kb.noText': 'Тексту ще немає',
  'kb.noTextHint': 'Документ ще не заповнено — зверніться до відповідального.',
  'kb.noTextHintManager': 'Відкрийте «Редагувати» і вставте текст або імпортуйте файл .md / .txt.',
  'kb.history': 'Історія версій',
  'kb.current': 'Чинна',
  'kb.publishedAt': 'опубліковано {at} · {by}',
  'kb.openDraft': 'Відкрити чернетку',
  'kb.publish': 'Опублікувати версію {n}',
  'kb.publishTitle': 'Опублікувати версію {n}?',
  'kb.publishHint': 'Версія стане чинною для всіх, хто має доступ; дата перегляду зсунеться на період перегляду.',
  'kb.publishHintAck': 'Версія стане чинною, а цільові ролі отримають прохання ознайомитися (Telegram і сповіщення в Bridge).',
  'kb.publishConfirm': 'Опублікувати',
  'kb.published': 'Версію опубліковано',
  'kb.archive': 'В архів',
  'kb.archiveTitle': 'Перенести документ в архів?',
  'kb.archiveHint': 'Співробітники більше не бачитимуть його, нагадування про ознайомлення припиняться.',
  'kb.restore': 'Відновити',
  'kb.restoreTitle': 'Відновити документ з архіву?',
  'kb.newTitle': 'Новий документ',
  'kb.editTitle': 'Редагування документа',
  'kb.editHint': 'Налаштування діють одразу; зміни тексту, назви чи файлу зберігаються як чернетка нової версії до публікації.',
  'kb.docTitle': 'Назва',
  'kb.code': 'Код',
  'kb.codeHint': 'Напр. ІЗВР-3, SOP-7',
  'kb.category': 'Розділ',
  'kb.chooseCategory': 'Оберіть розділ',
  'kb.roles': 'Кому доступний',
  'kb.ackRequired': 'Потрібне ознайомлення з кожною новою версією',
  'kb.ackRoles': 'Хто має ознайомитися',
  'kb.ackRolesHint': 'Не обрано жодної ролі — ознайомлюються всі, хто бачить документ.',
  'kb.ackDays': 'Строк, днів',
  'kb.body': 'Текст (Markdown)',
  'kb.bodyHint': '# заголовок, - список, 1. нумерація, **жирний**, [посилання](https://…)',
  'kb.write': 'Текст',
  'kb.preview': 'Перегляд',
  'kb.file': 'Файл',
  'kb.fileHint': 'PDF, Word, Excel, зображення — до 20 МБ',
  'kb.chooseFile': 'Обрати файл',
  'kb.removeFile': 'Прибрати файл',
  'kb.changeNote': 'Що змінилося',
  'kb.changeNoteHint': 'Побачать у запиті на ознайомлення та в історії',
  'kb.draftNotice': 'Документ уже опубліковано: зміни тексту збережуться як чернетка, доки ви її не опублікуєте.',
  'kb.saved': 'Збережено',
  'kb.savedDraft': 'Чернетку збережено — опублікуйте, коли буде готово',
  'kb.importTitle': 'Імпорт регламентів',
  'kb.importHint': 'Файли .md або .txt стануть чернетками розділу. Назва — перший заголовок «# …» або ім’я файлу; заготовка з такою ж назвою отримає текст.',
  'kb.importFiles': 'Файли',
  'kb.importFilesHint': 'До 50 файлів .md або .txt у UTF-8',
  'kb.importChosen': 'Обрано файлів: {n}',
  'kb.chooseFiles': 'Обрати файли',
  'kb.importRun': 'Імпортувати',
  'kb.importNoFiles': 'Оберіть файли .md або .txt',
  'kb.importAction.created': 'Створено',
  'kb.importAction.filled': 'Заповнено',
  'kb.importAction.updated': 'Нова чернетка',
  'kb.importAction.skipped': 'Пропущено',
  'kb.register.overdueOnly': 'Лише прострочені',
  'kb.register.empty': 'Усі ознайомилися вчасно',
  'kb.register.emptyHint': 'Тут з’являться співробітники, які ще не підтвердили ознайомлення з чинними версіями.',
  'kb.register.document': 'Документ',
  'kb.register.person': 'Співробітник',
  'kb.register.requested': 'Запит',
  'kb.register.due': 'Строк',
  'kb.position.status.to_confirm': 'Потребує затвердження',
  'kb.position.status.approved': 'Затверджено',
  'kb.position.status.archived': 'Архів',
  'kb.use.website': 'Сайт',
  'kb.use.discharge': 'Виписки',
  'kb.use.assistant': 'ШІ-асистент',
  'kb.use.articles': 'Статті',
  'kb.use.call_center': 'Колл-центр',
  'kb.positions.hint': 'Єдині позиції клініки для сайту, виписок і відповідей клієнтам. Показано лише затверджені головним лікарем.',
  'kb.positions.hintEditor':
    'Питання, щодо яких тексти сайту, статті й лікарі говорять різне. Запропонуйте формулювання — головний лікар затверджує; до затвердження в публічних текстах позиція не використовується.',
  'kb.positions.showArchived': 'Показати архівні',
  'kb.positions.empty': 'Затверджених позицій ще немає',
  'kb.positions.emptyHint': 'Коли головний лікар затвердить позиції, вони з’являться тут.',
  'kb.positions.notApproved': 'Позицію ще не затверджено.',
  'kb.positions.proposal': 'Пропозиція на затвердження',
  'kb.positions.approvedBy': 'Затвердив(ла) {name}, {date} · версія {n}',
  'kb.positions.approve': 'Затвердити',
  'kb.positions.approveTitle': 'Затвердити позицію «{title}»?',
  'kb.positions.approveHint': 'Цей текст стане офіційною позицією клініки для сайту, виписок і ШІ-асистента; попередній залишиться в історії.',
  'kb.positions.approved': 'Позицію затверджено',
  'kb.positions.propose': 'Запропонувати зміну',
  'kb.positions.write': 'Написати позицію',
  'kb.positions.editHint': 'Запропонований текст чекатиме затвердження головного лікаря; затверджений до того часу лишається чинним.',
  'kb.positions.question': 'Питання',
  'kb.positions.statement': 'Формулювання позиції',
  'kb.positions.statementHint': 'Коротко, без неперевірених цифр; з посиланням на джерела нижче',
  'kb.positions.sources': 'Джерела',
  'kb.positions.usedIn': 'Де використовується',
  'kb.positions.archived': 'В архіві (більше не використовується)',
  'kb.positions.saved': 'Збережено — чекає затвердження',
}

export const kbEn: { [K in keyof typeof kbUk]?: string } = {
  'nav.kb': 'Knowledge base',
  'perm.kb.read': 'Knowledge base: reading and acknowledgement',
  'perm.kb.manage': 'Knowledge base: documents, publishing, acknowledgement register',
  'perm.kb.approve_clinical': 'Approving clinical positions',
  'today.kbPending': 'To acknowledge',
  'kb.title': 'Knowledge base',
  'kb.subtitle': 'Clinic regulations, SOPs, scripts and instructions — with versions, review dates and acknowledgement',
  'kb.new': 'Document',
  'kb.import': 'Import',
  'kb.tab.docs': 'Documents',
  'kb.tab.positions': 'Clinical positions',
  'kb.tab.register': 'Acknowledgement',
  'kb.categories': 'Sections',
  'kb.allCategories': 'All sections',
  'kb.pendingCount': 'Waiting for acknowledgement: {n}',
  'kb.search': 'Search titles and texts',
  'kb.filter.allLevels': 'All levels',
  'kb.filter.role': 'For role',
  'kb.filter.allRoles': 'All roles',
  'kb.filter.current': 'Current and drafts',
  'kb.filter.pending': 'To acknowledge',
  'kb.filter.review': 'Review due',
  'kb.empty': 'No documents here yet',
  'kb.emptyHint': 'Regulations published for your role will appear here.',
  'kb.emptyHintManager': 'Create a document or import texts (.md, .txt) with «Import», then publish.',
  'kb.emptySearch': 'Try another word or the start of a word — search covers titles, codes and texts.',
  'kb.hasFile': 'Has an attachment',
  'kb.draftPending': 'New draft',
  'kb.reviewOn': 'Review {date}',
  'kb.versionShort': 'Version {n}',
  'kb.level': 'Level',
  'kb.level.policy': 'Policy',
  'kb.level.process': 'Process',
  'kb.level.procedure': 'Procedure / SOP',
  'kb.level.form': 'Form / template',
  'kb.access': 'Access',
  'kb.access.all': 'All staff',
  'kb.access.roles': 'Selected roles',
  'kb.access.managers': 'Managers only',
  'kb.status': 'Status',
  'kb.status.draft': 'Draft',
  'kb.status.published': 'In force',
  'kb.status.archived': 'Archived',
  'kb.document': 'Document',
  'kb.draftVersion': 'Draft, version {n}',
  'kb.oldVersion': 'Earlier version {n}',
  'kb.ack.ask': 'Read the document and confirm acknowledgement',
  'kb.ack.button': 'I have read it',
  'kb.ack.thanks': 'Thank you, acknowledgement recorded',
  'kb.ack.done': 'Acknowledged',
  'kb.ack.doneAt': 'You acknowledged it {at}',
  'kb.ack.due': 'Acknowledge by {date}',
  'kb.ack.overdue': 'Overdue',
  'kb.ack.summary': 'Acknowledged: {acked} of {targets}',
  'kb.ack.overdueCount': 'overdue: {n}',
  'kb.owner': 'Owner',
  'kb.ownerHint': 'Gets the review reminder',
  'kb.effectiveOn': 'In force since',
  'kb.reviewDate': 'Review date',
  'kb.reviewDateHint': 'Empty — by the period from publishing',
  'kb.reviewMonths': 'Review every, months',
  'kb.reviewMonthsHint': 'E.g. 12; OHS instructions — 60 (36 for high-risk work)',
  'kb.version': 'Version',
  'kb.source': 'Source',
  'kb.noText': 'No text yet',
  'kb.noTextHint': 'The document is not filled in yet — ask its owner.',
  'kb.noTextHintManager': 'Open «Edit» and paste the text, or import a .md / .txt file.',
  'kb.history': 'Version history',
  'kb.current': 'Current',
  'kb.publishedAt': 'published {at} · {by}',
  'kb.openDraft': 'Open the draft',
  'kb.publish': 'Publish version {n}',
  'kb.publishTitle': 'Publish version {n}?',
  'kb.publishHint': 'The version becomes current for everyone with access; the review date moves by the review period.',
  'kb.publishHintAck': 'The version becomes current and the target roles are asked to acknowledge it (Telegram and Bridge notifications).',
  'kb.publishConfirm': 'Publish',
  'kb.published': 'Version published',
  'kb.archive': 'Archive',
  'kb.archiveTitle': 'Move the document to the archive?',
  'kb.archiveHint': 'Staff will no longer see it and acknowledgement reminders stop.',
  'kb.restore': 'Restore',
  'kb.restoreTitle': 'Restore the document from the archive?',
  'kb.newTitle': 'New document',
  'kb.editTitle': 'Edit document',
  'kb.editHint': 'Settings apply at once; changes of the text, title or file are kept as a draft of a new version until published.',
  'kb.docTitle': 'Title',
  'kb.code': 'Code',
  'kb.codeHint': 'E.g. ІЗВР-3, SOP-7',
  'kb.category': 'Section',
  'kb.chooseCategory': 'Choose a section',
  'kb.roles': 'Available to',
  'kb.ackRequired': 'Acknowledgement required for every new version',
  'kb.ackRoles': 'Who must acknowledge',
  'kb.ackRolesHint': 'No role selected — everyone who sees the document acknowledges.',
  'kb.ackDays': 'Days to acknowledge',
  'kb.body': 'Text (Markdown)',
  'kb.bodyHint': '# heading, - list, 1. numbered, **bold**, [link](https://…)',
  'kb.write': 'Text',
  'kb.preview': 'Preview',
  'kb.file': 'File',
  'kb.fileHint': 'PDF, Word, Excel, images — up to 20 MB',
  'kb.chooseFile': 'Choose a file',
  'kb.removeFile': 'Remove the file',
  'kb.changeNote': 'What changed',
  'kb.changeNoteHint': 'Shown in the acknowledgement request and the history',
  'kb.draftNotice': 'The document is published: text changes are kept as a draft until you publish it.',
  'kb.saved': 'Saved',
  'kb.savedDraft': 'Draft saved — publish it when ready',
  'kb.importTitle': 'Import regulations',
  'kb.importHint': '.md or .txt files become drafts of the section. The title is the first «# …» heading or the file name; a seeded draft with the same title gets the text.',
  'kb.importFiles': 'Files',
  'kb.importFilesHint': 'Up to 50 .md or .txt files in UTF-8',
  'kb.importChosen': 'Files chosen: {n}',
  'kb.chooseFiles': 'Choose files',
  'kb.importRun': 'Import',
  'kb.importNoFiles': 'Choose .md or .txt files',
  'kb.importAction.created': 'Created',
  'kb.importAction.filled': 'Filled',
  'kb.importAction.updated': 'New draft',
  'kb.importAction.skipped': 'Skipped',
  'kb.register.overdueOnly': 'Overdue only',
  'kb.register.empty': 'Everyone acknowledged in time',
  'kb.register.emptyHint': 'Staff who have not confirmed current versions yet appear here.',
  'kb.register.document': 'Document',
  'kb.register.person': 'Staff member',
  'kb.register.requested': 'Requested',
  'kb.register.due': 'Due',
  'kb.position.status.to_confirm': 'To be approved',
  'kb.position.status.approved': 'Approved',
  'kb.position.status.archived': 'Archived',
  'kb.use.website': 'Website',
  'kb.use.discharge': 'Discharge texts',
  'kb.use.assistant': 'AI assistant',
  'kb.use.articles': 'Articles',
  'kb.use.call_center': 'Call centre',
  'kb.positions.hint': 'The clinic’s single positions for the website, discharge texts and answers to clients. Only those approved by the chief doctor are shown.',
  'kb.positions.hintEditor':
    'Questions where the website, articles and doctors say different things. Propose wording — the chief doctor approves; until then the position is not used in public texts.',
  'kb.positions.showArchived': 'Show archived',
  'kb.positions.empty': 'No approved positions yet',
  'kb.positions.emptyHint': 'Positions appear here once the chief doctor approves them.',
  'kb.positions.notApproved': 'Not approved yet.',
  'kb.positions.proposal': 'Proposal for approval',
  'kb.positions.approvedBy': 'Approved by {name}, {date} · version {n}',
  'kb.positions.approve': 'Approve',
  'kb.positions.approveTitle': 'Approve the position «{title}»?',
  'kb.positions.approveHint': 'This text becomes the clinic’s official position for the website, discharge texts and the AI assistant; the previous one stays in the history.',
  'kb.positions.approved': 'Position approved',
  'kb.positions.propose': 'Propose a change',
  'kb.positions.write': 'Write the position',
  'kb.positions.editHint': 'The proposed text waits for the chief doctor’s approval; the approved one stays in force until then.',
  'kb.positions.question': 'Question',
  'kb.positions.statement': 'Wording of the position',
  'kb.positions.statementHint': 'Short, without unverified figures; with the sources below',
  'kb.positions.sources': 'Sources',
  'kb.positions.usedIn': 'Used in',
  'kb.positions.archived': 'Archived (no longer used)',
  'kb.positions.saved': 'Saved — waiting for approval',
}
